var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "netgsm-extensions" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { icon: "reload", loading: _vm.loading },
                on: { click: _vm.refreshExtensions },
              },
              [_vm._v(" Yenile ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-alert",
        {
          staticClass: "webhook-alert",
          attrs: { message: "Webhook Address", type: "success" },
        },
        [
          _c("div", { attrs: { slot: "description" }, slot: "description" }, [
            _c("div", { staticClass: "webhook-info" }, [
              _c(
                "span",
                [
                  _c("a-icon", {
                    attrs: { type: "copy" },
                    on: { click: _vm.copyWebhookAddress },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.getWebhookAddress()))]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.extensions,
              loading: _vm.loading,
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Dahililer")]),
      _vm._v(" "),
      _c("p", [_vm._v("NetGSM telefon dahililerini yönetin")]),
      _vm._v(" "),
      _c("small", { staticClass: "websocket-info" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
        _vm._v(
          "\n                Web telefonu için sadece WebSocket (WSS) transport'u olan dahililer kullanılabilir\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }